import { HttpHeaders, HttpResponse } from '@angular/common/http';
import { RequestOptions } from '@app/types';
import { InvestmentPlanVirtualDepositTransferRequestDTO } from '@backend/dto';
import { Request } from '@backend/requests/request';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

export class InvestmentPlanVirtualDepositTransferRequest extends Request<
  InvestmentPlanVirtualDepositTransferRequestDTO,
  string
> {
  constructor(options?: RequestOptions<InvestmentPlanVirtualDepositTransferRequestDTO>) {
    super({
      ...options,
      method: 'POST',
      path: `${options?.version ?? '/v1'}/users/me/investment_plans/${
        options?.pathParams?.investmentPlanIdentifier
      }/transfers/deposit/virtual`,
      headers: new HttpHeaders().set('Content-Type', 'application/json')
    });
  }

  public execute(): Observable<string> {
    return super.execute().pipe(map((response: HttpResponse<string>) => response.body));
  }
}

export function createInvestmentPlanVirtualDepositTransfer(
  options?: RequestOptions<InvestmentPlanVirtualDepositTransferRequestDTO>
): InvestmentPlanVirtualDepositTransferRequest {
  return new InvestmentPlanVirtualDepositTransferRequest(options);
}
